import React, { Fragment, useEffect, useState } from "react";
// import { Card, CardBody, CardHeader, Col } from "reactstrap";
import { Card, CardBody, Col, Table } from "reactstrap";
import { H5, P } from "../../../AbstractElements";
import HeaderCard from "../../Common/Component/HeaderCard";
import {
  Recentsubscribers,
  Name,
  Status,
  Email,
  Phone,
  Industry,
} from "../../../Constant";
import { Link } from "react-router-dom";
import { getRecentSubscription } from "../../../CommonURL";
import { getDataWithToken } from "../../../Utils/restUtils";
import { toast } from "react-toastify";

const RecentSubscription = ({ industryId, year }) => {
  const [subscriptionData, setSubscriptionData] = useState([]);

  useEffect(() => {
    recentSubData();
  }, [industryId, year]);

  const recentSubData = async () => {
    let url = getRecentSubscription;

    const params = [];
    if (industryId) params.push(`industry_type_id=${industryId}`);
    if (year) params.push(`year=${year}`);

    if (params.length) {
      url = `${getRecentSubscription}?${params.join("&")}`;
    }

    const data = await getDataWithToken(url);
    if (data.status) {
      setSubscriptionData(data.data);
    } else {
      toast.error(data.message);
    }
  };

  return (
    <Fragment>
      <Col xxl="6" xl="6" lg="6" md="12" sm="12">
        <Card className="transaction-history" style={{ height: "580px" }}>
          <HeaderCard title={Recentsubscribers} setting={true} />
          <CardBody>
            <div
              className="table-responsive sroller-style"
              style={{ height: "550px", overflowY: "auto", padding: "7px" }}
            >
              <Table className="table table-bordernone table-responsive">
                <thead>
                  <tr>
                    <th>{Name}</th>
                    {/* <th>{Email}</th> */}
                    <th>{Industry}</th>
                    <th>{Phone}</th>
                    <th>{Status}</th>
                  </tr>
                </thead>
                <tbody>
                  {subscriptionData.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <Link
                            style={{ color: "#5F0F40", marginLeft: "13px" }}
                            to={`${process.env.PUBLIC_URL}/subscriptions/company-list/userProfile?id=${item.id}`}
                          >
                            <H5>{item.user_name}</H5>
                          </Link>
                          <H5>{item.email}</H5>
                        </td>
                        <td>
                          <H5>{item.industry_type_name}</H5>
                        </td>
                        <td>
                          <H5>{item.mobile}</H5>
                        </td>
                        <td>
                          <div>
                            <P
                              attrPara={{
                                className: `badge badge-${item.plan_type}`,
                                style: { color: "white" },
                              }}
                            >
                              {item.plan_type}
                            </P>
                            {/* <div className={`progress ${item.class}`} style={{ height: "5px" }}>
                                                        <div className="progress-bar" role="progressbar" style={{ width: `${item.progress}` }} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div > */}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <div className="text-end mt-3 pb-3">
                <Link
                  to={`${process.env.PUBLIC_URL}/subscriptions/active-sub`}
                  style={{
                    color: "#5F0F40",
                    fontWeight: "600",
                    textDecoration: "none",
                  }}
                >
                  View More →
                </Link>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
      {/* <Col xxl="5" lg="4" sm="6 box-col-40">
                <Card className="recent-order">
                    <CardHeader className="pb-0">
                        <H3>{RecentOrders}</H3>
                    </CardHeader>
                    <CardBody className="pb-0">
                        <div className="medium-chart">
                            <div className="recent-chart" id="recent-chart">
                                <Chart options={RecentChart.options} series={RecentChart.series} type="area" height={355} />
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </Col> */}
    </Fragment>
  );
};

export default RecentSubscription;
